import { DossierComments } from 'functions/commons';

export interface DossierCommentsInputData {
  dossierComments: DossierComments[];
}

export interface DossierCommentsSave {
  type: 'save';
  dossierComments: DossierComments[];
}

export interface DossierCommentsCancel {
  type: 'cancel';
}

export type DossierCommentsOutputData =
  | DossierCommentsSave
  | DossierCommentsCancel;
